import { motion } from "motion/react";
import Typing from "../../components/ui/Typing";
import {useState, useEffect} from "react"
import userEvent from "@testing-library/user-event";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Alfredo from '../../assets/imagens/Alfredo.png'


import './Apresentacao.css'
import Button from "../../components/ui/Button";

//Tela que apresenta o jogo ao novo usuário 
export default function Apresentacao(){
    const [indexText, setIndexText] = useState(0)

    const navigate = useNavigate()
    const {user} = useAuth()

    const nome = user.name.split(" ")

    const textAp = [
        {
            "index": 1,
            "text": `Olá ${nome[0]}, \n Seja bem-vindo à Semana da TI! \n Eu sou o Alfredo e vou acompanhar você nessa missão...`
        },
        {
            "index": 2,
            "text": `Aqui você vai aprender na prática como nossos colegas de TI trabalham para resolver os problemas do dia a dia...`
        },
        {
            "index": 3,
            "text": `Mas atenção... \n Os chamados têm  PRAZO para serem resolvidos. \n Você precisa analisar cada situação, escolher a melhor solução e ficar de olho no relógio... \n Quanto mais rápido resolver, mais XP você ganha!`
        },
        {
            "index": 4,
            "text": `E fique ligado, ${nome[0]}! \n TODOS OS DIAS haverá novos chamados disponíveis para você resolver. \n Não deixe de acompanhar a plataforma para não perder nenhuma oportunidade de subir no ranking!`
        },
        {
            "index": 5,
            "text": `Tudo pronto? \n Seus primeiros chamados estão chegando... \n BOA SORTE, ${nome[0]}!`
        }
    ]

    const handleAvancar = () =>{
        if(indexText === textAp.length - 1){
            navigate('/inicial')
            return
        }
        setIndexText(indexText+1)
    }


    return (
        <div className="container">
            <div className="flex">
                <motion.img 
                    animate={{y:[0,-4,0]}}
                    transition={{
                        duration:3,
                        repeat:Infinity,
                        ease:'easeInOut'
                    }}
                    className="imgAlfredo" src={Alfredo} />

                <div className="textoApresentacao">
                    <Typing text={textAp[indexText].text} className="textDark"/>

                    <Button
                        className="btnAmarelo"
                        text="Avançar" 
                        onClick={handleAvancar} >
                    </Button>
                </div>
            </div>
        </div>
    )
}